import axios from 'axios';
import {
  addNotificationPD,
  setIsFetchError, setIsOnlyOnceVariantUpd, setUsisCommonModalStep,
  setUsisData,
  setUsisModalStep,
  setWaitingRequest,
} from '../containers/PassportUpload/actions';
import {
  ESIA_USIS_MODAL_STEPS,
  REQUIRED_ACTIONS_STATUSES,
  STATE_STATUSES,
} from '../containers/PassportUpload/constants';
import { selectNotificationDetails } from '../containers/PassportUpload/selectors';

const ENDPOINTS = {
  usisResultPopup: '/api/texts/lk-update-personal-data-model/',
  checkStatusEsiaConsent: '/api/profile/userInfo/esiaState/',
  getEsiaOnceUrl: '/api/profile/userInfo/esiaOnceUrl/',
  getEsiaAutoUrl: '/api/profile/userInfo/esiaAutoUrl/',
};

export const esiaUsisRequest = async () => {
  try {
    const { data } = await axios.get(ENDPOINTS.usisResultPopup);

    if (data) {
      return data;
    }

    return {};
  } catch (err) {
    console.error(`Couldn't get esiaUsisRequest ${err}`);
  }
};

export const getEsiaOnceUrl = async (params) => {
  const config = { params };

  try {
    const { data } = await axios.get(ENDPOINTS.getEsiaOnceUrl, config);

    if (data) {
      return data;
    }

    return {};
  } catch (err) {
    console.error(`Couldn't get esiaOnceUrl ${err}`);
  }
};

export const getEsiaAutoUrl = async (params) => {
  const config = { params };

  try {
    const { data } = await axios.get(ENDPOINTS.getEsiaAutoUrl, config);

    if (data) {
      return data;
    }
  } catch (err) {
    console.error(`Couldn't get esiaAutoUrl ${err}`);
  }
};

export const checkStatusEsiaConsent = () => async (dispatch) => {
  dispatch(setIsOnlyOnceVariantUpd(false));

  try {
    const { data } = await axios.get(ENDPOINTS.checkStatusEsiaConsent);

    if (data) {
      return data;
    }
  } catch (err) {
    console.error(`Couldn't get checkStatusEsiaConsent ${err}`);
    dispatch(setIsOnlyOnceVariantUpd(true));
  }
};

export const getEsiaUsisData = () => async (dispatch) => {
  try {
    const data = await esiaUsisRequest();

    if (data) {
      dispatch(setUsisData(data));
      return;
    }
  } catch (error) {
    console.error(`Couldn't get data: ${error} `);
    dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.internalSystemError));
  }
};

export const redirectByEsiaAutoUrl = (params) => async (dispatch) => {
  try {
    const data = await getEsiaAutoUrl(params);

    const { esiaUrl } = data;

    if (esiaUrl) {
      window.open(esiaUrl, '_self');
      return;
    }
  } catch (error) {
    console.error(`Couldn't get esiaAutoUrl: ${error} `);
    dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.internalSystemError));
  }
};

export const redirectByEsiaOnceUrl = (params) => async (dispatch) => {
  try {
    const data = await getEsiaOnceUrl(params);

    const { url } = data;

    if (url) {
      window.open(url, '_self');
      return;
    }
  } catch (error) {
    console.error(`Couldn't get esiaOnceUrl: ${error} `);
    dispatch(setUsisCommonModalStep(ESIA_USIS_MODAL_STEPS.internalSystemError));
  }
};

export const initAfterCheckStatusEsia = (requiredAction) => async (dispatch, getState) => {
  dispatch(setWaitingRequest(true));
  dispatch(setIsFetchError(false));

  const storeState = getState();
  const esiaUrlOnceUpdParams = storeState?.settings?.passportUpload?.usisData?.data?.mainParams?.once;

  try {
    const response = await dispatch(checkStatusEsiaConsent());

    const { state } = response;

    if (state === STATE_STATUSES.AVAILABLE) {
      dispatch(setUsisModalStep(ESIA_USIS_MODAL_STEPS.MAIN));
      return;
    }

    if (state === STATE_STATUSES.ISSUED) {
      if (requiredAction === REQUIRED_ACTIONS_STATUSES.RENEW) {
        dispatch(setUsisModalStep(ESIA_USIS_MODAL_STEPS.outdatedDataError));
        return;
      }

      if (requiredAction === REQUIRED_ACTIONS_STATUSES.CONFIRM) {
        dispatch(setUsisModalStep(ESIA_USIS_MODAL_STEPS.notConfirmedDataError));
        return;
      }

      if (requiredAction === REQUIRED_ACTIONS_STATUSES.NONE) {
        dispatch(setUsisModalStep(ESIA_USIS_MODAL_STEPS.SERVICE_TIED));
        return;
      }

      dispatch(setIsOnlyOnceVariantUpd(true));
      return;
    }

    dispatch(setIsOnlyOnceVariantUpd(true));
  } catch (error) {
    console.error(`Couldn't check status of Esia: ${error}`);
  } finally {
    dispatch(setWaitingRequest(false));
  }
};
